var exports = {
  "k": "x4c3adb35--1bf737--container",
  "A": "x4c3adb35--1bf737--item",
};

module.exports = exports;
